import { useTooltip } from "context/TooltipProvider";
import { useTranslation } from "react-i18next";
import { FC, useEffect, useState } from "react";
import { editInstruction } from "services/doubtfulService";
import { fetchAdminUnitDetail } from "services/organizationService";
import { DoubtfulCase } from "types";
import { LoadingIcon } from "utils/constant";
import { errorHandlerOnForm } from "utils/helper";

type Props = {
  instruction: DoubtfulCase;
  onClose: (refetch: boolean) => void;
};

const RegistrarForm: FC<Props> = ({ instruction, onClose }) => {
  const { showTooltip } = useTooltip();
  const { t } = useTranslation();
  const [formState, setFormState] = useState<DoubtfulCase>({});
  const [loading, setLoading] = useState(false);
  const [adminUnitDetail, setAdminUnitDetail] = useState<any>();

  useEffect(() => {
    if (instruction) {
      fetchAdminUnitDetail(
        instruction?.admin_unit_id,
        instruction?.org_id,
      ).then((data) => {
        if (data) {
          setAdminUnitDetail(data);
        }
      });
    }
  }, [instruction]);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateForm = () => {
    // if (!formState.registrar_refernece_out) return "Reference Out is Required.";

    return "";
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    const error = validateForm();
    if (error) {
      showTooltip(error, "error");
      return;
    }

    setLoading(true);

    editInstruction({
      ...formState,
      id: instruction.id,
      request_status: "forwarded_to_cordinator_giving",
      org_id: "", //instruction.org_id,
      admin_unit_id: adminUnitDetail?.admin_unit?.parent_unit,
      transferred_from_admin_unit_id: instruction.org_id,
    })
      .then(() => {
        showTooltip(t("successfully_submitted"), "success");
        setFormState({});
        onClose(true);
        setLoading(false);
      })
      .catch((error) => {
        showTooltip(
          error?.response?.data?.detail || errorHandlerOnForm(error),
          "error",
        );
        setLoading(false);
      });
  };

  const handleClickOutside = (e: any) => {
    if (e.target.classList.contains("fixed")) {
      onClose(false);
    }
  };

  return (
    <div
      style={{ marginTop: "0px" }}
      className="fixed inset-0 z-50 flex justify-end bg-black bg-opacity-50 backdrop-blur-sm p-4"
      onClick={handleClickOutside}
    >
      <div className="relative w-full max-w-2xl bg-white p-8 shadow-lg rounded-lg overflow-y-auto">
        <h2 className="mb-1 text-2xl font-semibold">
          {t("registrar_reference")}
        </h2>
        <p className="mb-6 text-xs font-light text-[#9D9D9D]">
          {t("registrar_reference_subtitle")}
        </p>

        <form className="space-y-4" onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 gap-2 gap-x-4 mt-4">
            {instruction?.giving_team_members &&
            instruction?.giving_team_members?.length > 0 ? (
              <div className="flex flex-col mt-4 w-full">
                <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                  {t("registrar_reference_in")}
                </label>
                <input
                  className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                  name="registrar_refernece_out"
                  value={formState?.registrar_refernece_out || ""}
                  onChange={handleChange}
                />
              </div>
            ) : (
              <div className="flex flex-col mt-4 w-full">
                <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                  {t("registrar_reference_out")}
                </label>
                <input
                  className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                  name="registrar_refernece_no_out"
                  value={formState?.registrar_refernece_no_out || ""}
                  onChange={handleChange}
                />
              </div>
            )}
          </div>

          <div className="flex justify-end mt-4">
            <button
              type="submit"
              className={`border border-[#212121] bg-[#212121] px-[76px] py-2 
                                  text-white font-[Poppins] cursor-pointer font-[500] text-base rounded-md hover:bg-[#414040]
                                          ${
                                            loading
                                              ? "opacity-50 cursor-not-allowed"
                                              : ""
                                          }`}
              disabled={loading}
            >
              {loading ? (
                <div className="flex items-center justify-center">
                  {LoadingIcon}
                  {t("loading")}
                </div>
              ) : (
                t("registrar_reference")
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RegistrarForm;
